// About two lines of slack, so a reader resting just above the end still counts as there.
export const NEAR_BOTTOM_PX = 48;

export interface ScrollPosition {
    scrollTop: number;
    scrollHeight: number;
    clientHeight: number;
}

export function isNearBottom({ scrollTop, scrollHeight, clientHeight }: ScrollPosition): boolean {
    return scrollHeight - scrollTop - clientHeight <= NEAR_BOTTOM_PX;
}
